<template>
  <a-plane
    opacity="0"
    width="5"
    height="5"
    material="depthTest: false"
    @loaded="elLoaded"
    position="0 0 .2"
  >
    <a-entity ref="circle" scale="0 0 0">
      <a-circle
        color="#fc1f1f"
        ref="circle_multiply"
        position="0 0 .005"
        radius=".2"
        segments="32"
        transparent="true"
        material="shader: flat"
      />
      <a-circle
        color="#fc1f1f"
        ref="circle_additive"
        position="0 0 .005"
        radius=".2"
        segments="32"
        transparent="true"
        opacity="0"
        material="shader: flat"
      />
      <ProgressCircle />
    </a-entity>
  </a-plane>
</template>

<script>
import _ from 'lodash'
import Settings from '@/config/Settings'
import ProgressCircle from './ProgressCircle'

export default {
  name: 'CursorComp',
  components: { ProgressCircle },
  beforeDestroy() {
    window.removeEventListener('mousemove', this.onMouseMove)
  },
  watch: {
    '$route': 'setCircle',
    vr() {
      if(this.vr)
        TweenLite.to(this.$refs.circle, .5, { aframe: { x: 0, y: 0 }})

      this.setCircle()
    }
  },
  methods: {
    setCircle() {
      const routeName = this.$route.meta.name
      const visibleIn = ['wait', 'start', 'level', 'captation', 'explorer', 'vrstart']
      if(!this.vr)
        visibleIn.push('conclusion')
      const type = this.$route.params.captation || routeName == 'wait' ? 'dark' : 'light'
      const circleSize = this.vr ? .07 : .1

      TweenLite.to(this.$refs.circle, 1, { aframe: { scale: visibleIn.indexOf(routeName) > -1 ? circleSize : 0 } })

      TweenLite.to(this.$refs.circle_additive, 2, { aframe: { alpha: type == 'dark' ? .4 : 0 } })

      // color
      let color = (routeName == 'level' || routeName == 'captation') && !this.conclusion ? this.levels[this.$route.params.level] : this.levels['intro-3']
      if(routeName == 'explorer')
        color = this.levels.explore

      if(routeName == 'vrstart')
        color = 'grey'

      if(this.$route.params.captation)
        color = this.levels[this.$route.params.level]

      TweenLite.to([this.$refs.circle_multiply, this.$refs.circle_additive], 1, { aframe: { color: color }})
    },
    elLoaded(e) {
      this.$refs.circle_multiply.object3DMap.mesh.material.blending = THREE.MultiplyBlending
      this.$refs.circle_additive.object3DMap.mesh.material.blending = THREE.AdditiveBlending

      window.addEventListener('mousemove', this.onMouseMove)

      this.$raycaster = new THREE.Raycaster()
      this.$overlay = this.$el.object3DMap.mesh
      this.$camera = this.$parent.$el.object3D

      this.setCircle()
    },
    onMouseMove(event) {
      if(this.vr || this.$root.$agent.mobile) return

      const mouse = {
				x: ( event.clientX / window.innerWidth ) * 2 - 1,
				y: - ( event.clientY / window.innerHeight ) * 2 + 1
			}
      this.$raycaster.setFromCamera(mouse, this.$el.sceneEl.camera)
      const intersects = this.$raycaster.intersectObjects([this.$overlay])

      if(intersects.length > 0) {
				const vector = new THREE.Vector3().copy(intersects[0].point)
        intersects[0].object.worldToLocal(vector)
        TweenLite.to(this.$refs.circle, .2, { aframe: { x: vector.x, y: vector.y }, ease: Linear.easeInOut })
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/cursor/Cursor.vue